import { RECORD_STATE } from "../../constants";
import { Singleton } from "../Singleton";
import { generalBody } from "../alertBodies";
export const Strategies_Preview_RecState = {
    "Callout": function(message,that){
        that.props.setCallId({callOutId: message.CallOutId,callId:message.CallId, calloutMaxTime: message.CalloutMaxTime})
    },
    "Dialog": function(message,that){ 
        !that.props.preview.simultaneosRecs && previewProcess( that)
        
        const timeInSec = getCurrentTimeInSec();

        if(message.ActivePreview)
        { 
            that.props.changePreviewRecordStatus({callOutId: message.CallOutId, status:RECORD_STATE.DIALOG});
            that.props.setInitialDialogTime({callOutId: message.CallOutId, timeOnDialog: timeInSec});
            that.props.setSelectedRecord(message.CallOutId)
        }
        else
        {
            that.props.changePreviewRecordStatus({callOutId: message.CallOutId, status:RECORD_STATE.HOLD});

        }     
    },

    "RingingListening": function(message,that){
        that.props.changePreviewRecordStatus({callOutId: message.CallOutId, status:RECORD_STATE.DIALING})
    },
    
    "ALERT": function( message, that){
        if(message.Code === "1508" && message.DialResultID === 13)
        {
            that.props.changePreviewRecordStatus({callOutId: message.CallOutId, status:RECORD_STATE.DEFAULT})
        }
        else
        {
            that.props.changePreviewRecordStatus({callOutId: message.CallOutId, status:RECORD_STATE.ALERT, messageStatus:message.Code})
        }
    },

    "Wrapup":function(message,that){
        const  lastSelectedRecord = that.props.preview.selectedRecord;
        const recordToChange =  that.props.preview.records.filter(r=>r.callOutId === message.CallOutId)[0];
        if(recordToChange.status === RECORD_STATE.DIALOG || recordToChange.status === RECORD_STATE.WAITING_WRAPUP )
        {
            that.props.changePreviewRecordStatus({callOutId: message.CallOutId ? message.CallOutId : lastSelectedRecord.callOutId , status:RECORD_STATE.WRAPUP, messageStatus: message.Code})
        } else if(recordToChange.status === RECORD_STATE.HOLD)
        {
            if(message.AgentHangUp)
            {
                that.props.changePreviewRecordStatus({callOutId: message.CallOutId ? message.CallOutId : lastSelectedRecord.callOutId , status:RECORD_STATE.WRAPUP, messageStatus: message.Code})
            }else
            {
                that.props.changePreviewRecordStatus({callOutId: message.CallOutId, status:RECORD_STATE.ABANDONED, messageStatus: ''})
            }
        }
    },
    "dialogTime": function(message,that){
        if(Math.round(message.dialogTime) !== 0)
        {
            that.props.setDialogTimeSimultaneousView({callOutId: message.CallOutId, dialogTime: Math.round(message.dialogTime)})
        }
    },
    "Hold": function(message,that){
        that.props.changePreviewRecordStatus({callOutId: message.CallOutId, status:RECORD_STATE.HOLD})
    },
    "NotReady": function(message,that){
        that.props.cleanData();
    },
    "BeforeWrapup": function(message,that){
        that.props.changePreviewRecordStatus({callOutId: message.CallOutId, status:RECORD_STATE.WAITING_WRAPUP,messageStatus: ''})
    },
    "notReadyScheduled": function(message,that){
        that.props.setNDScheduled();
    }
}

const previewProcess = (that) =>{
    that.props.setDialogTime(undefined);
    let previewTime = that.props.preview.totalPreviewTime;
    that.props.actionPreviewRecord(
    { 
        process:7,
        camId: that.props.preview.isSendProcess ? that.props.preview.camId : that.props.preview.tempPrevRecord.camId,
        callOutId: that.props.preview.isSendProcess ? that.props.preview.callOutId : that.props.preview.tempPrevRecord.callOutId,
        previewTime: that.props.preview.isSendProcess ? previewTime: that.props.preview.tempPrevRecord.previewTime,
        callId:  that.props.preview.isSendProcess ? that.state.dataCall.CallId : that.props.preview.tempPrevRecord.callId
    }) ;
    that.props.setIsSendProcess(true);
 };

export function getCurrentTimeInSec(){
    const currentTime = new Date();
    const currentHourInSeconds = currentTime.getHours()*3600;
    const currentMinutesInSeconds = currentTime.getMinutes()*60
    const currentSeconds = currentTime.getSeconds();
    return currentHourInSeconds + currentMinutesInSeconds + currentSeconds;
}

export const errorsMessagePreviewSR = (errorCode, phone='', isSnackbar = false)=> {
    const language = new Singleton();
    let textBody = '';
    switch(errorCode){
        case '1500':
            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-busy-line')
            break;
        case '1501':
            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-not-answered')
            break;
        case '1502':
            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-fax-modem')
            break;
        case '1503':
            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-am-voicemail')
            break;
        case '1504':
            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-no-dial-tone')
            break;
        case '1505':
            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-busy-circuit')
            break;
        case '1506':
            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-other')
            break;
        case '1507':
            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-out-of-service')
            break;
        case '1508':
            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-cancelled')
            break;
        case '1509':
        case '1510':
        case '1511':
            textBody = language.getText('GUIPreviewSimultaneousAlertsnotify-not-answered')
            break;
        case '1512':
            textBody = isSnackbar ? language.getText('GUIPreviewSimultaneousAlertscancelled-on-answer-mssg').replace('[n]',`[${phone}]`) : language.getText('GUIDialResultCancelledByEngaged')
            break;
        default:
            textBody = generalBody(language.getText('alert-' + errorCode))
            break;
    }
    return textBody;
}



// WEBPACK FOOTER //
// ./src/js/Strategies/Strategies_Preview_RecState.js